import { combineReducers } from '@reduxjs/toolkit';
import { authReducer } from './auth/reducer';
import { configReducer } from './config/reducer';
import { connectionsReducer } from './connections/reducer';
import { envReducer } from './env/reducer';
import { languageReducer } from './language/reducer';
import { modalReducer } from './modal/reducer';
import { navReducer } from './nav/reducer';
import { scrollReducer } from './scrollPage/reducer';
const reducerMap = {
  config: configReducer,
  nav: navReducer,
  modal: modalReducer,
  env: envReducer,
  auth: authReducer,
  scrollPage: scrollReducer,
  lang: languageReducer,
  connections: connectionsReducer
};
export const rootReducer = combineReducers(reducerMap);